import type React from 'react';

import clsx from 'clsx';

import { ButtonBadge } from './ButtonBadge';

export interface NextButtonProps {
  text: string;
  onClick: () => void;
  disabled?: boolean;
  destructive?: boolean;
  halfSized?: boolean;
  buttonRounded?: boolean;
  shortcutBadge?: string;
  width?: string;
}

const NextButton: React.FC<NextButtonProps> = ({
  text,
  onClick,
  disabled,
  destructive = false,
  halfSized = false,
  buttonRounded = false,
  shortcutBadge = undefined,
  width = undefined,
}) => {
  const buttonClass = halfSized
    ? 'w-[222px] h-10 rounded-3xl bg-smallBgBtn px-6'
    : 'max-w-[444px] w-full h-15 rounded-3xl';

  return (
    <button
      className={clsx(
        destructive ? 'bg-[#FF0000!]' : '',
        buttonRounded ? 'rounded-full bg-darkBgBtn' : buttonClass,
        disabled ? 'bg-[rgba(0,0,0,0.12)]' : 'bg-smallBgBtn',
        'h-[50px]',
        width ? `w-[${width}]` : 'w-full',
      )}
      disabled={disabled}
      onClick={onClick}
      type="button"
    >
      <span className="font-Barlow text-[22px] font-bold text-white">{text}</span>
      {shortcutBadge && <ButtonBadge text={shortcutBadge} />}
    </button>
  );
};

export default NextButton;
